module.exports = __webpack_public_path__ + "static/media/Hanna.08578772.jpg";